import React, {createContext, useState, useContext, useEffect} from 'react';
import {inPersistentStore} from "../utils/storage.util";
import {ManutencaoService} from "../pages/tabelasDeControle/services/manutencaoService";

type AppContextState = {
    setRenderIncludeScreen: React.Dispatch<React.SetStateAction<boolean>>;
    setRenderIncludePerfilOrLista: React.Dispatch<React.SetStateAction<boolean>>;
    setFiltersDashboard: React.Dispatch<React.SetStateAction<any>>;
    setManageItem: React.Dispatch<React.SetStateAction<object>>;
    setNewLayout: React.Dispatch<React.SetStateAction<boolean>>;
    setMaintenanceMode: React.Dispatch<React.SetStateAction<boolean>>;
    renderIncludeScreen: boolean;
    renderIncludePerfilOrLista: boolean;
    filtersDashboard: any;
    manageItem: object;
    newLayout: boolean;
    maintenanceMode: boolean;
};

const AppContext = createContext<AppContextState | null>(null);

type AppProviderProps = {
    children?: React.ReactNode;
};

export const AppProvider = ({children}: AppProviderProps) => {
    const isNewLayout = inPersistentStore.getItem('newLayout') || false;
    const [renderIncludeScreen, setRenderIncludeScreen] =
        useState<boolean>(false);
    const [renderIncludePerfilOrLista, setRenderIncludePerfilOrLista] =
        useState<boolean>(false);
    const [filtersDashboard, setFiltersDashboard] = useState<any>({});
    const [manageItem, setManageItem] = useState<object>({});
    const [newLayout, setNewLayout] = useState<boolean>(isNewLayout);
    const [maintenanceMode, setMaintenanceMode] = useState<boolean>(false);

    useEffect(() => {
        const loadData = async () => {
            try {
                const data = await ManutencaoService.manutencaoAdmin();
                if(data) {
                    setMaintenanceMode(true);
                } else {
                    setMaintenanceMode(false);
                }
            } catch (e) {
                setMaintenanceMode(false);
            }
        }
        loadData()
    }, []);

    return (
        <AppContext.Provider
            value={{
                renderIncludeScreen,
                setRenderIncludeScreen,
                renderIncludePerfilOrLista,
                setRenderIncludePerfilOrLista,
                filtersDashboard,
                setFiltersDashboard,
                manageItem,
                setManageItem,
                newLayout,
                setNewLayout,
                maintenanceMode,
                setMaintenanceMode
            }}
        >
            {children}
        </AppContext.Provider>
    );
};

export const useApp = (): AppContextState => {
    const context = useContext(AppContext);

    if (context === null) {
        throw new Error(`useApp must be used within a AppProvider`);
    }

    return context;
};
